/**
 * This function just redirects to
 * the given URL. Pulled this out to its
 * own function to make unit testing easier.
 * @param url
 */
export const redirectTo = (url: string) => {
  window.location.assign(url);
};
